import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { trackingTypes, trackingNullValue } from '../../constants';
import { PromotionPositionContext, FeatureFlagsContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";

const Trackable = _ref => {
  let {
    children,
    trackingAction,
    type,
    correlationId,
    displayId,
    title,
    position,
    creative,
    promotion
  } = _ref;
  const enableMeasurement = useContext(FeatureFlagsContext).NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT;
  return /*#__PURE__*/_jsx(PromotionPositionContext.Consumer, {
    children: promotionPosition => enableMeasurement ? /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, type === trackingTypes.promotion && {
      'data-promotion': true
    }), {}, {
      "data-trackable-action": trackingAction,
      "data-trackable-correlation-id": correlationId || displayId || trackingNullValue,
      "data-promotion-id": correlationId || displayId || trackingNullValue,
      "data-promotion-name": title || position || trackingNullValue,
      "data-promotion-creative": creative || promotion && promotion.creative || trackingNullValue,
      "data-promotion-slot": promotionPosition || position || trackingNullValue,
      "data-id": "trackable_index_Trackable_div",
      children: children
    })) : /*#__PURE__*/_jsx("div", {
      "data-id": "trackable_index_Trackable_div_1",
      children: children
    })
  });
};

export default Trackable;